import { useGetIndexNotificationsQuery } from "../../store/api/signularisApi";
import React, { useState } from "react";
import { Button, Pagination, Result, Select, Skeleton } from "antd";
import { Link } from "react-router-dom";
import { GetNotificationsRequest, NotificationType } from "../../types/types";
import style from './Home.module.scss';
import { 
    CheckCircleFilled, 
    ExclamationCircleFilled, 
    InfoCircleFilled, 
    ClockCircleOutlined 
} from '@ant-design/icons';

const { Option } = Select;

const Home = () => {
    const [skip, setSkip] = useState<number>(0);
    const [limit, setLimit] = useState<number>(20);
    const [currentPage, setCurrentPage] = useState<number>(1);

    let reqParams: GetNotificationsRequest = { skip, limit };

    const { data, isLoading, isError, refetch } = useGetIndexNotificationsQuery(reqParams, {
        refetchOnFocus: true,
        refetchOnMountOrArgChange: true
    });

    const notifications = data?.notifications;
    const count = data?.count;

    if (isError) return (
        <Result
            status="error"
            title="Ошибка загрузки"
            subTitle="Не удалось получить список уведомлений"
            extra={<Button type="primary" onClick={() => refetch()}>Повторить попытку</Button>}
        />
    );

    if (isLoading) return (
        <div className={style.container}>
            {[1, 2, 3, 4].map(i => <Skeleton.Button key={i} active block style={{ height: 80, borderRadius: 16, marginBottom: 12 }} />)}
        </div>
    );

    const getStatusProps = (type: NotificationType) => {
        switch (type) {
            case "signed":
                return { icon: <CheckCircleFilled />, color: '#10b981', bg: '#ecfdf5' };
            case "rejected":
                return { icon: <ExclamationCircleFilled />, color: '#b92034', bg: '#fef2f2' };
            default:
                return { icon: <InfoCircleFilled />, color: '#3b82f6', bg: '#eff6ff' };
        }
    };

    const formatDateTime = (time: string) => {
        const t = new Date(time);
        const date = t.toLocaleDateString('ru-RU', { day: '2-digit', month: '2-digit', year: 'numeric' });
        const hours = t.getHours().toString().padStart(2, '0');
        const minutes = t.getMinutes().toString().padStart(2, '0');
        return { date, time: `${hours}:${minutes}` };
    };

    return (
        <div className={style.container}>
            <div className={style.topBar}>
                <h3 className={style.title}>Последние уведомления</h3>
                <Select defaultValue={20} onChange={(v) => setLimit(v)} size="small" bordered={false} style={{ width: 80 }}>
                    <Option value={20}>20</Option>
                    <Option value={50}>50</Option>
                    <Option value={100}>100</Option>
                </Select>
            </div>

            {notifications?.length ? (
                <>
                    {notifications.map(({ type, text, link, createdAt }, idx) => {
                        const status = getStatusProps(type);
                        const { date, time } = formatDateTime(createdAt);
                        return (
                            <div key={idx} className={style.notificationCard}>
                                <div className={style.statusLine} style={{ backgroundColor: status.color }} />
                                <div className={style.contentWrapper}>
                                    <div className={style.iconBox} style={{ backgroundColor: status.bg, color: status.color }}>
                                        {status.icon}
                                    </div>
                                    <div className={style.text}>
                                        <Link to={link.slice(12)}>{text}</Link>
                                    </div>
                                </div>
                                <div className={style.meta}>
                                    <span className={style.date}>{date}</span>
                                    <span className={style.time}><ClockCircleOutlined /> {time}</span>
                                </div>
                            </div>
                        );
                    })}

                    <div className={style.paginationWrapper}>
                        <Pagination
                            current={currentPage}
                            total={count}
                            pageSize={limit}
                            onChange={(page) => {
                                setSkip(limit * (page - 1));
                                setCurrentPage(page);
                            }}
                            showSizeChanger={false}
                        />
                    </div>
                </>
            ) : (
                <Result icon={<InfoCircleFilled style={{ color: '#cbd5e1' }} />} title="Уведомлений пока нет" />
            )}
        </div>
    );
};

export default Home;
